import PaymentDisbursementTransferCard from './PaymentDisbursementTransferCard';

export default PaymentDisbursementTransferCard;
